import {RenewProjectFormValidationSchema} from '@/features/projects/formSchemas'
import {ProjectExtended} from '@/features/projects/types'
import {ensureWorkingDay, getNextWorkingDay} from '@/features/projects/utils'
import {zodResolver} from '@hookform/resolvers/zod'
import dayjs from 'dayjs'
import {ReactNode} from 'react'
import {FormProvider, useForm} from 'react-hook-form'

export const RenewProjectFormProvider = ({
    children,
    project,
    holidays
}: {
    children: ReactNode
    project: ProjectExtended
    holidays: {date: string}[]
}) => {
    const startDate = project.durationDays
        ? getNextWorkingDay(dayjs(project.startDate).add(project.durationDays, 'day').toDate(), holidays)
        : undefined

    const expirationDate =
        project.durationDays && startDate
            ? ensureWorkingDay(dayjs(startDate).add(project.durationDays, 'day').toDate(), holidays)
            : undefined

    const form = useForm<RenewProjectFormValidationSchema>({
        mode: 'onBlur',
        resolver: zodResolver(RenewProjectFormValidationSchema),
        defaultValues: {
            id: project.id,
            patient: {
                id: project.patient?.id,
                fullName: project.patient?.fullName,
                serviceType: project.patient?.serviceType
            },
            referringProject: project,
            // extended and maintenance sectors are deprecated sectors, so we convert them to mixed
            sector: project.sector == 'extended' || project.sector == 'maintenance' ? 'mixed' : project.sector,
            assistiveRegime: project.assistiveRegime || undefined,
            startDate,
            expirationDate,
            durationDays: project.durationDays ? project.durationDays : undefined,
            sender: project.sender || undefined,
            specialist: project.specialist || undefined
        }
    })

    return <FormProvider {...form}>{children}</FormProvider>
}
